import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { fallback: String, manual: Boolean };

  beginAutomation() { this.automationId = null; }

  claimAutomation(automationId) {
    if (this.manualValue) return false;
    this.automationId = automationId;
    return true;
  }

  finishAutomation() {
    if (this.manualValue || this.automationId === null) this.updateSrc(this.fallbackValue);
  }

  updateSrc(url) {
    if (this.element.getAttribute('src') !== url) this.element.setAttribute('src', url);
  }
}
